import { useContext } from 'react';
import { PermissionContext } from '../context/permission-context';

const usePermissionsContext = () => useContext(PermissionContext);

export default usePermissionsContext;
